/**
 * This file defines the root module of the Angular 1 of the application.
 */
// import angular1
import * as angular from "angular";
import "angular-route";
import "angular-ui-bootstrap";
import "angular-cookies";
import "angular-resource";
import "lodash";
import "angular-sanitize";
import "ng-file-upload";
import "angular-translate";
import "angular-translate-loader-static-files";
import "../../config/application.js";
import "../../config/imports.js";
import "../../config/sara_config";

export const Sara1AppModule = angular.module('Sara1AppModule', [
    'ngResource',
    'ngCookies',
    'ui.bootstrap',
    'pascalprecht.translate',
    'ngSanitize',
    'ngFileUpload',
    'CarsSaraBo'
]);



// WEBPACK FOOTER //
// ./public/upgrade/saraV1_app.ts